import config from '../../config/config';

export const DOMO_REPORT_FAILURE = 'DOMO_REPORT/DOMO_REPORT_FAILURE';
export const DOMO_REPORT_LOAD = 'DOMO_REPORT/DOMO_REPORT_LOAD';
export const DOMO_REPORT_SUCCESS = 'DOMO_REPORT/DOMO_REPORT_SUCCESS';

export function getDomoReport() {
    return {
        failureActionTypeOrCreator: getDomoReportFailureActionCreator,
        fetchParams: {
            url: `${config.underwritingApiUrl}/onboarding/reports/domo`
        },
        loadActionTypeOrCreator: DOMO_REPORT_LOAD,
        successActionTypeOrCreator: getDomoReportSuccessActionCreator
    };
}

export function getDomoReportFailureActionCreator(error) {
    return {
        error,
        type: DOMO_REPORT_FAILURE
    };
}

export function getDomoReportSuccessActionCreator(response) {
    return {
        embedData: response.embedData || response,
        type: DOMO_REPORT_SUCCESS
    };
}
